<template>
  <div class="option" :class="classes">
    <Button
      class="option__btn"
      variant="outline"
      block
      draggable
      v-on="$listeners"
    >
      <DragIcon class="option__drag" />
      <div class="option__content">
        <span class="option__title"><slot /></span>
        <div class="option__desc"><slot name="description" /></div>
      </div>
    </Button>
    <Badge class="option__badge" v-if="isPro" aria-hidden="true">Pro</Badge>
  </div>
</template>

<script>
import { Button, Badge, DragIcon } from '@campsite-bio/component-lib';
import { computed, toRefs } from '@nuxtjs/composition-api';

export default {
  components: {
    Button,
    Badge,
    DragIcon,
  },

  props: {
    isPro: Boolean,
    variant: {
      type: String,
      default: null,
    },
  },

  setup(props) {
    const { variant } = toRefs(props);

    const classes = computed(() => {
      return {
        'option--btn': variant.value === 'button',
      };
    });
    return { classes };
  },
};
</script>

<style lang="scss" scoped>
.option__btn.option__btn {
  border: 1.5px dashed var(--g-color-primary);
  border-radius: var(--g-border-radius-min);
  cursor: move;
  padding: 0.45em 0.75em;
  text-align: left;

  @media (min-width: 552px) {
    padding: 0.45em 1.25em;
  }

  .option--btn & {
    border-style: solid;
    cursor: pointer;
  }

  &::v-deep .v-button__content {
    justify-content: flex-start;
  }
}

.option {
  position: relative;

  &--btn {
    .option__drag {
      display: none;
    }
  }

  &__drag {
    margin-left: -0.75rem;
    margin-right: 0.45rem;
    font-size: 1.25em !important;
  }

  &__title {
    font-weight: 700;
  }

  &__desc {
    font-size: 0.75rem;
  }

  &__badge {
    pointer-events: none;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(30%, -30%);
  }
}
</style>
